import { sendRawRequest, sendJsonRequest } from "./utils";

const AVATAR_URL = "/core/feeds/avatar/";

export function uploadAvatarUrl(logo) {
    return sendJsonRequest(AVATAR_URL, "POST", { logo });
}

export function uploadAvatar(file) {
    const payload = new FormData();
    payload.append("logo", file);
    return sendRawRequest(AVATAR_URL, "POST", payload);
}
